import { render } from "./HeaderLinks.vue?vue&type=template&id=5ca1a3fc"
import script from "./HeaderLinks.vue?vue&type=script&lang=js"
export * from "./HeaderLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__